import {
  mapFromDocumentOutputLocation,
  mapFromDocumentOutputLocationStatus,
} from 'mappings/documentOutputLocationMapping';
import { InternalAuditReportSettingsDTO } from 'models/dto/internalAuditReportSettingsDTO';
import InternalAuditReportSettings from 'models/internalAuditReportSettings';

export function mapFromInternalAuditReportSettings(dto: InternalAuditReportSettingsDTO): InternalAuditReportSettings {
  const output = new InternalAuditReportSettings();

  output.location = mapFromDocumentOutputLocation(dto.location);
  output.status = mapFromDocumentOutputLocationStatus(dto.status);
  output.folderDriveItemId = dto.folderDriveItemId;
  output.folderName = dto.folderName;
  output.folderUrl = dto.folderUrl;

  return output;
}
